
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.537 11.536a4.008 4.008 0 010-5.667L25.667 3 3 25.667l2.869 2.869a4.007 4.007 0 115.667 5.664l2.8 2.8L37 14.333l-2.8-2.8a4.007 4.007 0 01-5.663.003zm.244 8.331a1.5 1.5 0 110-2.126 1.5 1.5 0 010 2.126zm-3.261-3.262a1.5 1.5 0 110-2.126 1.5 1.5 0 010 2.126zm-3.261-3.261a1.5 1.5 0 110-2.125 1.5 1.5 0 010 2.125z"}})])
          )
        }
      }
    